import { useEffect, useState } from "react"
import Headings from "./Headings"
// import Search from "./Search"
import Item from "./Item"
import Modal from "./Modal"

// down arrow &#x25BC;

const FILTERS = ["Date", "Track", "City", "Status"];


const cache = {

  Track: ['SWE', 'UX', 'PM', 'DA', 'DM', 'IT'],
  Date: ['May 2', 'May 3', 'May 4', 'May 5', 'May 6', 'May 7', 'May 8', 'May 9', 'May 10', 'May 11', 'May 12', 'May 13', 'May 14', 'May 15', 'May 16'],
  City: ["ATL", "AUS", "CHI", "MLT", "NYC", "REM"],
  Status: ["Submitted Application", "Received Questionnaire", "Interviewing", "Received Offer"]

}

// const keywords = ['SWE', 'UX', 'DA', 'DM', 'IT'];

function List({ tempArray }) {

  const [allApplicants, setAllApplicants] = useState([])
  const [entries, setEntries] = useState([])
  const [keywords, setKeywords] = useState([])

  ///
  const [showFilterBtn, setShowFilterBtn] = useState(true)
  // const [filteredApps, setFilteredApps] = useState([])

  const [filterBy, setFilterBy] = useState("");
  const [keyword, setKeyword] = useState("");

  const [open, setOpen] = useState(false)



  // const getApplicants = async ()=>{

  //     const res = await fetch('http://localhost:4000/');
  //     const applicants = await res.json();
  //     setAllApplicants(applicants);

  // }

  useEffect(() => {
    window.onbeforeunload = () =>
      window.scrollTo(0, 0);

  })

  useEffect(() => {
    //get applicants from backend
    //getApplicants();

    setAllApplicants(tempArray)
    setEntries(tempArray)


  }, [tempArray])

  function handleReset(e) {
    setFilterBy("")
    setShowFilterBtn(true);
    setEntries(allApplicants)
    //setFilteredApps([])
  }
  function handleSubmit(e) { //
    e.preventDefault();
    //set filtered hook here but need to get
    setShowFilterBtn(false)
    //alert(keyword)
    //const filtered = allApplicants.filter(el=>el[filterBy.toLowerCase()]=== keyword);


    const filtered = allApplicants.filter(el => {

      if (filterBy === "Date") {
        return el[filterBy.toLowerCase()] === +keyword.substring(keyword.length - 2).trim();
      } else {
        return el[filterBy.toLowerCase()] === keyword;
      }
    })

    setEntries(filtered)
    console.log(filtered)

  }

  // // const filtered = allApplicants.filter(el=>el[filterBy]=== keyword);
  //   const entries =  filteredApps || allApplicants;
  const components = entries && entries.map(el => <Item key={el.userId} className={`row ${el.status === "Received Offer" && 'clickable'}`} el={el} handleClick={() => setOpen(true)} />)
  // const components = allApplicants.map(el=> <Item key= {el.userId} className="row" el={el}/>)


  return (
    <div className="list-cont">

      {/* <Search tempArray={tempArray}/> */}


      <div className="search-cont">

        <form onSubmit={handleSubmit}>


          <label htmlFor="filterBy">

            <select
              id="filter-by"
              value={filterBy}
              onChange={(e) => {
                setFilterBy(e.target.value);
                setKeywords(cache[e.target.value])
                setShowFilterBtn(true);
                setKeyword("")
              }}
              onBlur={(e) => {
                setFilterBy(e.target.value);
                setKeywords(cache[e.target.value])
                setShowFilterBtn(true);
                setKeyword("")
              }}
            >
              <option value="">Filter By <span id="down"> &#x25BC;</span></option>
              {FILTERS.map(filter => (
                <option key={filter} value={filter}>
                  {filter}
                </option>
              ))}
            </select>
          </label>




          {!filterBy.length ? null :
            <> <label htmlFor="keyword">

              <select
                id="keyword"
                value={keyword}
                onChange={(e) => {

                  setKeyword(e.target.value)
                  setShowFilterBtn(true);

                }}
                onBlur={(e) => {

                  setKeyword(e.target.value)
                  setShowFilterBtn(true);

                }}
              >
                <option value="">Choose {filterBy} &#x25BC; </option>

                {keywords.map(keyword => (
                  <option key={keyword} value={keyword}>
                    {keyword}
                  </option>
                ))}
              </select>

            </label>

              {showFilterBtn ? <button className="btn">FILTER</button> :
                <button className="btn" onClick={handleReset}>RESET</button>}
            </>


          }

        </form>
      </div>
      <div className="table-cont">
        <div className="table-wrapper">
          <Headings />
          {components}
        </div>
      </div>
      <Modal open={open} handleClose={() => setOpen(false)}>
        <h3>History</h3>
        <p>Track: </p>
        <p>Application Date: May </p>

      </Modal>
    </div>
  )
}

export default List

  // function handleClick(e){
    //     console.log(e.target.value)
    // }

    // const components = allApplicants.map(el=>(<h4 key= {el.userId} className="row">
    // <span className="id-col">{el.userId}</span>
    // <span className="username-col" id="namecol">{el.username}</span>
    // <span className="date-col">May {el.day}</span>
    // <span className="track-col">{el.track} </span>
    // <span className="city-col">{el.city}</span>
    // <span className={`status-col ${bg[el.status]}`}>{el.status} </span>
    // <span className="date-col">{el.statusDate}</span>
    // <span className="history-col" onClick={handleClick}> {"+"}  </span>
    // {/* <span className="history-col"> {"+"} {el.history[0].status} </span> */}
    // </h4>))